import type { DpopKeyPair } from './key';
import { generateDpopKeyPair } from './key';
import { isDpopSupported, saveDpopKeyPair } from './store';

// undefined when this browser cannot hold a key; the caller carries on without one
export async function createDpopLoginKeyPair(): Promise<DpopKeyPair | undefined> {
  if (!(await isDpopSupported())) return undefined;

  try {
    return await generateDpopKeyPair();
  } catch (error) {
    // partial WebCrypto in odd webviews — carry on without a key
    console.warn('Failed to create the auth key:', error);
    return undefined;
  }
}

// use this for logins instead of createDpopLoginKeyPair: it cannot forget to save.
// `origin` is the backend being logged in to — pass it whenever the login targets an explicit
// apiDomain, or the key lands under this page's own origin and the request hook never finds it.
export async function withDpopLoginBinding<TResult>(
  execute: (keyPair: DpopKeyPair | undefined) => Promise<TResult>,
  origin?: string,
): Promise<TResult> {
  const keyPair = await createDpopLoginKeyPair();
  const result = await execute(keyPair);
  // skipped on throw, and awaited so a login redirect cannot outrun the write
  if (keyPair) await saveDpopKeyPair(keyPair, origin);
  return result;
}
